import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import Welcome from './components/Welcome';
import ProtectedRoute from './components/ProtectedRoute';
import ConsentForm from './components/ConsentForm';
import Menu from './components/Menu';
import AdminLogin from './components/AdminLogin';
import AdminDashboard from './components/AdminDashboard';
import AdminMenu from './components/AdminMenu';
import AdminCodes from './components/AdminCodes';
import Heart from './components/Heart';
import Skeleton from './components/Skeleton';
import Neck from './components/Neck';
import SkullChest from './components/SkullChest';
import Chest from './components/Chest';
import Brain from './components/brain';
import Muscles from './components/Muscles';
import NervousSystem from './components/NervousSystem';
import LymphaticSystem from './components/LymphaticSystem';
import CardiovascularSystem from './components/CardiovascularSystem';
import DigestiveSystem from './components/DigestiveSystem';
import RespiratorySystem from './components/RespiratorySystem';
import UrinarySystem from './components/UrinarySystem';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/" element={<Welcome />} />
            <Route path="/consent" element={<ProtectedRoute><ConsentForm /></ProtectedRoute>} />
            <Route path="/menu" element={<ProtectedRoute><Menu /></ProtectedRoute>} />
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<ProtectedRoute adminOnly><AdminDashboard /></ProtectedRoute>} />
            <Route path="/admin/organs" element={<ProtectedRoute adminOnly><AdminMenu /></ProtectedRoute>} />
            <Route path="/admin/codes" element={<ProtectedRoute adminOnly><AdminCodes /></ProtectedRoute>} />
            <Route path="/heart" element={<ProtectedRoute><Heart /></ProtectedRoute>} />
            <Route path="/skeleton" element={<ProtectedRoute><Skeleton /></ProtectedRoute>} />
            <Route path="/neck" element={<ProtectedRoute><Neck /></ProtectedRoute>} />
            <Route path="/skullchest" element={<ProtectedRoute><SkullChest /></ProtectedRoute>} />
            <Route path="/chest" element={<ProtectedRoute><Chest /></ProtectedRoute>} />
            <Route path="/brain" element={<ProtectedRoute><Brain /></ProtectedRoute>} />
            <Route path="/muscles" element={<ProtectedRoute><Muscles /></ProtectedRoute>} />
            <Route path="/nervoussystem" element={<ProtectedRoute><NervousSystem /></ProtectedRoute>} />
            <Route path="/lymphaticsystem" element={<ProtectedRoute><LymphaticSystem /></ProtectedRoute>} />
            <Route path="/cardiovascularsystem" element={<ProtectedRoute><CardiovascularSystem /></ProtectedRoute>} />
            <Route path="/digestivesystem" element={<ProtectedRoute><DigestiveSystem /></ProtectedRoute>} />
            <Route path="/respiratorysystem" element={<ProtectedRoute><RespiratorySystem /></ProtectedRoute>} />
            <Route path="/urinarysystem" element={<ProtectedRoute><UrinarySystem /></ProtectedRoute>} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
